module.exports = __webpack_public_path__ + "static/img/noticeboard--small.5e8f130.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/corridor/noticeboard--small.svg
// module id = 160
// module chunks = 2